import React from 'react'

function Profile() {
    return (
        <div>
            profile
        </div>
    )
}

export default Profile
